import React from "react";

const Multiple_Inheritance = () => {
  return (
    <div>
      <h1>Multiple_Inheritance Component</h1>
      <p>Content for Multiple_Inheritance goes here...</p>
    </div>
  );
};

export default Multiple_Inheritance;
